import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { urlApi } from '../Constants/Global';

import SectionHeader from '../Components/SectionHeader';
import Bg from '../Medias/Photos/photo-bg7.jpg';
import SectionNoContent from '../Components/SectionNoContent';

const EnergyLawInThailand = ({ contents }) => {
  console.log(contents);

  return (
    <>
      <SectionHeader topic='Energy Law in Thailand' detail='This section provides the comprehensive and highly acclaimed book by Asst. Prof. Piti Eiamchamroonlarp on energy law in Thailand organized into 12 chapters.' bg={Bg} />
      <SectionNoContent />
    </>
  )
}

export default EnergyLawInThailand